import clientApiManager from '../clientApiManager'

export function productService(storefrontApiClient = clientApiManager) {
  return storefrontApiClient.get(`/4x4campaigns?campaignIds=${window.campaignsId}`);
}



// WEBPACK FOOTER //
// ./src/service/product/productService.js